module.exports = {
  recruitType: {
    0: '社招',
    1: '校招',
  },

  jobType: {
    21: '科技类',
    22: '非科技类',
  },
};
